import React from 'react';
import I18n from 'i18n-js';

import { RCTooltip } from '@reverbdotcom/cadence/components';
import { I18N } from '@reverbdotcom/commons/src/components/translate';

export interface PendingAmount {
  currency: string;
  count: string;
  formattedAmount: string;
}

export interface IPendingProps {
  pendingAmountsByCurrency?: PendingAmount[];
  children?: React.ReactNode;
}

export default function Pending({ pendingAmountsByCurrency = [], children = null }: IPendingProps) {
  if (pendingAmountsByCurrency.length === 0) {
    return null;
  }

  return (
    <div className="earnings-payouts__pending">
      <div className="d-flex fx-justify-between">
        <div className="earnings-payouts__pending__title">
          <div className="mr-1">
            {I18n.t('earnings.payouts.pending.title')}
          </div>
          <RCTooltip placement="right" text={I18n.t('earnings.payouts.pending.tooltip')} />
        </div>
      </div>
      <div className="d-flex fx-justify-between mobile-fx-dir-col fx-wrap gap-4">
        <div>
          {pendingAmountsByCurrency.map((pendingAmount, index) => (
            <div key={index} className="earnings-payouts__pending__pending-amount">
              <div className="earnings-payouts__pending__pending-amount__transactions">
                <div>
                  <I18N
                    html
                    text="earnings.payouts.pending.transactionsHtml"
                    args={{
                      spanOpen: '<span class="text-color-secondary">',
                      spanClose: '</span>',
                      currency: pendingAmount.currency,
                    }}
                  />
                </div>
                <div className="weight-bold size-120">
                  {pendingAmount.count}
                </div>
              </div>
              <span className="earnings-payouts__pending__pending-amount__balance">
                <div>

                  <I18N
                    html
                    text="earnings.payouts.pending.balanceHtml"
                    args={{
                      spanOpen: '<span class="text-color-secondary">',
                      spanClose: '</span>',
                      currency: pendingAmount.currency,
                    }}
                  />
                </div>
                <div className="weight-bold size-120">
                  {pendingAmount.formattedAmount}
                </div>
              </span>
            </div>
          ))}
        </div>
        <div>
          {children}
        </div>
      </div>
    </div>
  );
}
